import React from "react";
import { Select, Typography, Row, Col, Avatar, Card } from "antd";
import moment from "moment";
import { useGetCryptoNewsQuery } from "../services/cryptoNewsApi";

const { Text, Title } = Typography;
const { Option } = Select;

const News = ({ simplified }) => {
  const { data: cryptoNews, isLoading, error } = useGetCryptoNewsQuery({
    newsCategory: "Cryptocurrency",
    count: simplified ? 6 : 12,
  });

  if (isLoading) return <p>Loading...</p>;
  if (error) return <p>Error loading news</p>;
  if (!cryptoNews?.articles) return <p>No news found</p>;

  return (
    <Row gutter={[24, 24]}>
      {cryptoNews.articles.map((news, i) => (
        <Col xs={24} lg={12} key={i}>
          <Card hoverable className="news-card">
            <a href={news.url} target="_blank" rel="noreferrer">
              <div className="news-image-container">
                {news.urlToImage && (
                  <img
                    src={news.urlToImage}
                    alt="news"
                    style={{ width: "100px", height: "100px", marginRight: "10px" }}
                  />
                )}
                <Title className="news-title" level={4}>
                  {news.title}
                </Title>
              </div>
              <p>{news.description}</p>
              <div className="provider-container">
                <Text>{moment(news.publishedAt).fromNow()}</Text>
              </div>
            </a>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default News;
